import React from "react";
import { Card } from "react-bootstrap";

function Vision() {
  return (
    <Card
      className="wrapper_card p-0 my-3 vision-bg shadow"
      style={{ borderRadius: 1 + "rem" }}
    ></Card>
  );
}

export default Vision;
